export default "/images/vendor/leaflet-fullscreen/dist/fullscreen.png?f2c17d21245758a145e8a513ed4a65b0";